import { Component } from '@angular/core';

@Component({
  selector: 'chevron-down-icon',
  standalone: true,
  imports: [],
  templateUrl: './chevron-down.component.html',
  styleUrl: './chevron-down.component.scss'
})
export class ChevronDownIcon {

}
